import React from 'react';
import { SimulationConfig } from './types';
import { PhysicsSettingsSection } from './PhysicsSettingsSection';
import { AdvancedPhysicsSection } from './AdvancedPhysicsSection';
import { SpaceSpiralSettingsSection } from './SpaceSpiralSettingsSection';
import { OutsideColliderSection } from './OutsideColliderSection';
import { HyperSpeedSettingsSection } from './HyperSpeedSettingsSection';
import { CollapsibleSection } from './CollapsibleSection';

interface PhysicsTabProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const PhysicsTab: React.FC<PhysicsTabProps> = ({ config, setConfig }) => (
  <div className="flex flex-col w-full">
    <PhysicsSettingsSection config={config} setConfig={setConfig} />
    
    <CollapsibleSection title="Advanced Physics" icon="fa-microchip" darkMode={config.darkMode}>
        <AdvancedPhysicsSection config={config} setConfig={setConfig} />
    </CollapsibleSection>
    
    {/* Dynamic Mode-Specific Physics */}
    {config.mode === 'SPACE_SPIRAL' && (
      <CollapsibleSection title="Space Spiral Physics" icon="fa-vortex" darkMode={config.darkMode} defaultOpen>
        <SpaceSpiralSettingsSection config={config} setConfig={setConfig} />
      </CollapsibleSection>
    )}
    
    {config.mode === 'ESCAPE' && (
      <CollapsibleSection title="Hyper Speed Engine" icon="fa-bolt-lightning" darkMode={config.darkMode} defaultOpen>
        <HyperSpeedSettingsSection config={config} setConfig={setConfig} />
      </CollapsibleSection>
    )}
    
    <CollapsibleSection title="Boundary Colliders" icon="fa-border-all" darkMode={config.darkMode}>
        <OutsideColliderSection config={config} setConfig={setConfig} />
    </CollapsibleSection>
  </div>
);
